import Vue from "vue";
import Element from "element-ui";
import locale from "element-ui/lib/locale/lang/ko";

Vue.use(Element, { locale });
